module.exports = __webpack_public_path__ + "static/img/6336_phase_function_Paper_PointsHejduk_Prediction.3924bbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6336_phase_function_Paper_PointsHejduk_Prediction.png
// module id = GDEq
// module chunks = 0